import { useMemo } from 'react';
import {
  StepName,
  StepStatus,
  type InternshipProcessWithNames,
} from '../../Types/interfaces';

export const useReadyToSignConventionsOfProjectCoordinator = (
  internshipProcesses: Array<InternshipProcessWithNames>
) => {
  return useMemo(
    () =>
      internshipProcesses.filter((process) =>
        process.processSteps.some(
          (step) =>
            step.stepName ===
              StepName.SigningInternshipConventionByUniversityProjectCoordinator &&
            step.stepStatus === StepStatus.initialized &&
            !step.disabled
        )
      ),
    [internshipProcesses]
  );
};
